// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"QB-z","error":"RB-z","disabled":"SB-z"};